import { Component, Input, OnChanges } from '@angular/core';
import { DocumentReviewValidationRuleType } from '@enums/document-review-validation-rule-type.enum';
import { DocumentReviewValidationRuleTypeToValidationMessage } from '@models/mappers/maps/document-review-validation-rule-type-to-validation-message.resource.map';

@Component({
    selector: 'lex-doc-validation-message',
    templateUrl: './doc-validation-message.component.html',
    styleUrls: ['./doc-validation-message.component.scss'],
    standalone: false
})
export class DocValidationMessageComponent implements OnChanges {

  @Input() validationErrors: DocumentReviewValidationRuleType[];
  public errorMessages: string[] = [];
  public warningMessages: string[]= [];
  public infoMessages: string[]= [];

  ngOnChanges(): void {
    this.errorMessages = [];
    this.warningMessages = [];
    this.infoMessages = [];
    this.validationErrors.forEach(e => {
      if (e === DocumentReviewValidationRuleType.MissingRedactedPdf
        || (e === DocumentReviewValidationRuleType.PartialPrivilegedCoding)
        || (e === DocumentReviewValidationRuleType.PartialPrivilegedRedaction))
        this.warningMessages.push(DocumentReviewValidationRuleTypeToValidationMessage.get(e))

      if ((e === DocumentReviewValidationRuleType.PageCount)
        || (e === DocumentReviewValidationRuleType.ResponsiveInvalid)
        || (e === DocumentReviewValidationRuleType.ResponsiveEmailFamily)
        || (e === DocumentReviewValidationRuleType.PrivilegeEmailFamily)
        || (e === DocumentReviewValidationRuleType.WorkProductEmailFamily))
        this.infoMessages.push(DocumentReviewValidationRuleTypeToValidationMessage.get(e))
    });
  }
}